import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { LeaderBoardPage } from 'app/pages/leaderBoard/LeaderBoardPage'
import { SelfAssessPage } from 'app/pages/selfAssess/SelfAssessPage'
import { SelfAssessDetailPage } from 'app/pages/selfAssess/SelfAssessDetailPage'
import UseSeason from 'app/modules/core/hooks/season/UseSeason'
import { SpecialPage } from 'app/pages/special/SpecialPage'
import { SpecialDetailPage } from 'app/pages/special/SpecialDetailPage'
import { JobPage } from 'app/pages/job/JobPage'
import { JobDetailPage } from 'app/pages/job/JobDetailPage'
import { StatDetailPage } from 'app/pages/stat/StatDetailPage'
import { StatPage } from 'app/pages/stat/StatPage'
import { ProfileDetailPage } from 'app/pages/profile/ProfileDetailPage'
import { ProfileHealthPage } from 'app/pages/profile/ProfileHealthPage'
import { ProfilePage } from 'app/pages/profile/ProfilePage'
import { GradeBroadPage } from 'app/pages/leaderBoard/GradeBroadPage'
import { AnnouceSettingPage } from 'app/pages/setting/AnnouceSettingPage'
import { AnnouceSettingEditPage } from 'app/pages/setting/AnnouceSettingEditPage'
import { AnnounceDetailPage } from 'app/pages/announce/AnnounceDetailPage'
import { AnnounceBoardPage } from 'app/pages/announce/AnnounceBoardPage'
import { KpiSummaryPage } from 'app/pages/report/KpiSummaryPage'
import { SeasonSettingPage } from 'app/pages/setting/SeasonSettingPage'
import { SeasonSettingEditPage } from 'app/pages/setting/SeasonSettingEditPage'
import { SeasonNotStartPage } from 'app/pages/SeasonNotStartPage'
import { SelfSettingEditPage } from 'app/pages/setting/SelfSettingEditPage'
import { SelfSettingPage } from 'app/pages/setting/SelfSettingPage'
import { UserManagementPage } from 'app/pages/setting/UserManagementPage'
import { UserManagementEditPage } from 'app/pages/setting/UserManagementEditPage'
import { SelftSettingValidatePage } from 'app/pages/setting/SelftSettingValidatePage'
import { AdditionalPage } from 'app/pages/setting/AdditionalPage'

// import { useDispatch } from 'react-redux'
// import * as core from 'app/modules/core/redux/CoreReducer'

const PrivateRoutes = () => {
  //const dispatch = useDispatch(
 

  // const dispatch = useDispatch()
  // const logout = () => {
  //   dispatch(auth.actions.logout())

  // }
  return (
    <Routes>
      <Route element={<MasterLayout />}>

        <Route element={<SeasonNotStartPage />}>
          <Route path='auth/*' element={<Navigate to='/leaderboard' />} />
          <Route path='leaderboard' element={<LeaderBoardPage />} />
          <Route path='grade' element={<GradeBroadPage />} />
          <Route path='selfAssess' element={<SelfAssessPage />} />
          <Route path='selfAssessDetail/:period' element={<SelfAssessDetailPage />} />
          <Route path='special' element={<SpecialPage />} />
          <Route path='special-detail/:id' element={<SpecialDetailPage />} />
          <Route path='job' element={<JobPage />} />
          <Route path='job-detail/:id' element={<JobDetailPage />} />
          <Route path='stat' element={<StatPage />} />
          <Route path='stat-detail/:id' element={<StatDetailPage />} />
          <Route path='profile' element={<ProfilePage />} />
          <Route path='profile-detail/:id' element={<ProfileDetailPage />} />
          <Route path='profile-health/:id' element={<ProfileHealthPage />} />
          <Route path='announce' element={<AnnounceBoardPage />} />
          <Route path='announce/:id' element={<AnnounceDetailPage />} />

        
         
        </Route>

        <Route path='setting/announce' element={<AnnouceSettingPage />} />
        <Route path='setting/announce/:id' element={<AnnouceSettingEditPage />} />

        <Route path='report/kpi-summary' element={<KpiSummaryPage />} />
        
        <Route path='setting/seasons' element={<SeasonSettingPage />} />
        <Route path='setting/seasons/:id' element={<SeasonSettingEditPage />} />

        <Route path='setting/self' element={<SelfSettingPage />} />
        <Route path='setting/self/:id' element={<SelfSettingEditPage />} />

        <Route path='setting/users' element={<UserManagementPage />} />
        <Route path='setting/users/:id' element={<UserManagementEditPage />} />

        <Route path='setting/self-validate' element={<SelftSettingValidatePage/>} />
        <Route path='setting/additional' element={<AdditionalPage/>}/>
        
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />

        <Route
          path='account/*'
          element={
            <SuspensedView>

            </SuspensedView>
          }
        />

        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>

            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
